import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {EventService} from '../event.service';
import {StoryService} from '../story.service';
import {PointOfInterestService} from '../point-of-interest.service';
import {CategoryService} from "../category.service";

export const homeComponentResolver: ResolveFn<Promise<[void, void, void, void]>> = () => {
  return Promise.all([
    inject(StoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(EventService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(CategoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(PointOfInterestService).resolveIndex(RenderStrategy.PREFER_SERVER),
  ]);
};
